export default __webpack_public_path__ + "static/media/graphic_report.eba2e04c.jpg";